import { render, staticRenderFns } from "./Diymarket.vue?vue&type=template&id=2a5465e0&scoped=true&"
import script from "./Diymarket.vue?vue&type=script&lang=js&"
export * from "./Diymarket.vue?vue&type=script&lang=js&"
import style0 from "./Diymarket.vue?vue&type=style&index=0&id=2a5465e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5465e0",
  null
  
)

export default component.exports